"use client";

import React from "react";

import { createSVGIcon } from "../util";

/** @trackcomponent */
export const SocialInstagram = createSVGIcon(
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 6.5C3 4.01472 5.01472 2 7.5 2H17.5C19.9853 2 22 4.01472 22 6.5V16.5C22 18.9853 19.9853 21 17.5 21H7.5C5.01472 21 3 18.9853 3 16.5V6.5ZM7.5 3C5.567 3 4 4.567 4 6.5V16.5C4 18.433 5.567 20 7.5 20H17.5C19.433 20 21 18.433 21 16.5V6.5C21 4.567 19.433 3 17.5 3H7.5ZM8 11.5C8 9.01472 10.0147 7 12.5 7C14.9853 7 17 9.01472 17 11.5C17 13.9853 14.9853 16 12.5 16C10.0147 16 8 13.9853 8 11.5ZM12.5 8C10.567 8 9 9.567 9 11.5C9 13.433 10.567 15 12.5 15C14.433 15 16 13.433 16 11.5C16 9.567 14.433 8 12.5 8ZM17.5 5.5C16.9477 5.5 16.5 5.94772 16.5 6.5C16.5 7.05228 16.9477 7.5 17.5 7.5C18.0523 7.5 18.5 7.05228 18.5 6.5C18.5 5.94772 18.0523 5.5 17.5 5.5Z"
      fill="#333333"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "SocialInstagram",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      defaultMessage: "Instagram",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
  })
);
